'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback } from 'react';
import { getCoreProps } from '../core/core.utils.js';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useRequiredI18nProps, getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { TextInput } from '../text-input/text-input.component.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const SearchInput = renderWithRef('SearchInput', null, (i, _)=>{
    let y = useInternalOptionalSwanI18nContext();
    useRequiredI18nProps(i, [
        'accessibleTextForClearButton',
        'accessibleTextForSearchButton'
    ]), useDeprecatedProps('SearchInput', i, [
        {
            propName: 'accessibleTextForClearButton',
            instructions: getDeprecatedI18nPropMessage(y)
        },
        {
            propName: 'accessibleTextForSearchButton',
            instructions: getDeprecatedI18nPropMessage(y)
        }
    ]);
    let j = useRef(void 0), h = assignRefs(_, j), { skin: O = 'standard', disabled: w, onClear: x, onSearchSubmit: g, accessibleTextForClearButton: S, accessibleTextForSearchButton: v } = i, P = _object_without_properties(i, [
        "skin",
        "disabled",
        "onClear",
        "onSearchSubmit",
        "accessibleTextForClearButton",
        "accessibleTextForSearchButton"
    ]), k = getCoreProps(P), T = S, B = v;
    y && !T && (T = y.t('search-input.accessible-text-for-clear-button')), y && !B && (B = y.t('search-input.accessible-text-for-search-button'));
    let C = useCallback((e)=>{
        j.current && (j.current.value = '', j.current.focus()), x && x(e);
    }, [
        x
    ]), F = new Set([
        'swan-search-input'
    ]);
    return 'error' === O && F.add('swan-search-input-skin-error'), jsxs(RenderComp, {
        root: "div",
        classNames: F,
        props: _object_spread({}, k),
        children: [
            jsx(RenderComp, {
                forwardedRef: h,
                root: TextInput,
                props: _object_spread({
                    type: 'search',
                    disabled: w
                }, P)
            }),
            jsx(IconButton, _object_spread_props(_object_spread({
                className: "swan-search-input-clear",
                skin: "tertiary",
                onClick: C,
                "aria-label": T,
                disabled: w,
                tooltip: ""
            }, noTooltipInternal), {
                children: jsx(Icon, {
                    iconType: "clear"
                })
            })),
            jsx("span", {
                className: "swan-search-divider"
            }),
            jsx(IconButton, _object_spread_props(_object_spread({
                type: "submit",
                skin: "tertiary",
                className: "swan-search-input-submit",
                onClick: null != g ? g : void 0,
                "aria-label": B,
                disabled: w,
                tooltip: ""
            }, noTooltipInternal), {
                children: jsx(Icon, {
                    iconType: "search"
                })
            }))
        ]
    });
});

export { SearchInput };
